// extracted by mini-css-extract-plugin
module.exports = {"layout":"index_layout__2G1-z","head":"index_head__2ceCF","main":"index_main__3mZP_","aside":"index_aside__2YbZh","con":"index_con__iAH0a"};